export default function () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}



// WEBPACK FOOTER //
// ./scripts/utils/detect-mobile.js